


















































































import { snakeCase } from 'lodash'
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'

import {
  GroupedBotProperty,
  PropertyFieldType
} from '../../../../../../../../../../../BotProperties/components/Properties/types'
import UploadMediaDescriptors
  from '../../../../../../../../../../../MediaUploader/UploadMediaDescriptors.vue'
import { StepUnit } from '../../../../../../../../../../../PeriodSimplifier/types'
import { UseFields } from '../../../../../../../../../../../Pi'
import FieldTitle from '../../../../../../../../../../../Pi/components/FieldTitle.vue'
import { FieldData } from '../../../../../../../../../../../Pi/types'
import Picker from '../../../../../../../../../../../Picker/Picker.vue'
import { PickerFormat } from '../../../../../../../../../../../Picker/types'
import { PropValueConstant } from '../../../../../logic/Actions/PropertyAction/PropertyActionValue'
import { PropertyActionType } from '../../../../../logic/Actions/PropertyAction/types'
import { ActionNodeProps } from '../../../../../logic/types'

@Component({
  data() {
    return {
      snakeCase,
      PropertyActionType
    }
  },
  components: {
    UploadMediaDescriptors,
    Picker,
    FieldTitle
  }
})
export default class PropertyValueConstant extends Mixins(UseFields) {
  @Prop() value!: PropValueConstant

  @Prop() action!: PropertyActionType

  @Prop() getProperties!: () => Array<GroupedBotProperty>

  @Prop() currentProperty!: GroupedBotProperty | undefined

  @Prop() mediaTargetId!: ActionNodeProps['target']

  get filesViewValue() {
    return JSON.parse(this.value.value as string)
  }

  setValueHandler(arg: FieldData): FieldData {
    arg.setter = (val) => this.constValue = val
    return arg
  }

  get constValue(): string | number | boolean {
    return this.value.value
  }

  set constValue(val: string | number | boolean) {
    this.setConstValue(val)
  }

  @Emit()
  setConstValue(value: string | number | boolean): string | number | boolean {
    return value
  }

  get flagValue() {
    return !(this.value.value === 'false' || !this.value.value);
  }

  set flagValue(val) {
    this.setConstValue(val)
  }

  get timeFormat(): string | null {
    if (this.currentProperty) {
      if (this.currentProperty.type === PropertyFieldType.DateTime) {
        return PickerFormat.DateTime
      }

      if (this.currentProperty.type === PropertyFieldType.Date) {
        return PickerFormat.Date
      }

      return PickerFormat.Time
    }

    return null
  }

  get stepUnits(): Array<StepUnit> {
    const defaultUnits = [ StepUnit.Second, StepUnit.Minute, StepUnit.Day, StepUnit.Month ]

    if (this.currentProperty) {
      if ([ PropertyFieldType.Time, PropertyFieldType.DateTime ].includes(this.currentProperty.type)) {
        return defaultUnits
      }

      if (this.currentProperty.type === PropertyFieldType.Date) {
        return [ StepUnit.Day, StepUnit.Month ]
      }

      return defaultUnits
    }

    return defaultUnits
  }

  get isString(): boolean {
    if (this.currentProperty) {
      return [ PropertyFieldType.String, PropertyFieldType.Email, PropertyFieldType.Phone ].includes(this.currentProperty.type)
    }
    return false
  }

  get isNumber(): boolean {
    if (this.currentProperty) {
      return [ PropertyFieldType.Number, PropertyFieldType.Double ].includes(this.currentProperty.type)
    }
    return false
  }

  get isFlag(): boolean {
    if (this.currentProperty) {
      return [ PropertyFieldType.Flag ].includes(this.currentProperty.type)
    }
    return false
  }

  get isDate(): boolean {
    if (this.currentProperty) {
      return [ PropertyFieldType.DateTime, PropertyFieldType.Time, PropertyFieldType.Date ].includes(this.currentProperty.type)
    }
    return false
  }

  get isFiles(): boolean {
    if (this.currentProperty) {
      return [ PropertyFieldType.Files ].includes(this.currentProperty.type)
    }

    return false
  }

}
